function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M52.7097 25.8295C52.7097 11.5643 41.1462 0 26.8819 0H25.8277C11.5635 0 -7.62939e-06 11.5643 -7.62939e-06 25.8295C-7.62939e-06 40.0947 11.5635 51.659 25.8277 51.659H52.7097V25.8295Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.47 28.8941C30.47 16.3214 40.6623 6.12915 53.235 6.12915C65.8077 6.12915 76 16.3214 76 28.8941C76 41.4669 65.8077 51.6591 53.235 51.6591H30.47V28.8941Z",
  fill: "#C2FFE9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4582 38.0639C29.5488 38.0639 32.5501 36.9965 35.4624 34.8618L39.2958 40.9991C37.3345 42.3037 35.1949 43.3414 32.877 44.1123C30.6186 44.8239 28.4195 45.1796 26.2799 45.1796C22.1791 45.1796 18.5834 44.3495 15.4929 42.6891C12.4618 40.9695 10.1142 38.6272 8.45004 35.6623C6.78592 32.6974 5.95386 29.347 5.95386 25.6112C5.95386 21.994 6.84535 18.703 8.62834 15.7381C10.4708 12.7139 12.967 10.3419 16.1169 8.62228C19.2669 6.84333 22.714 5.95386 26.4582 5.95386C31.2723 5.95386 35.2841 7.37702 38.4934 10.2233C41.7623 13.0103 43.991 16.924 45.1796 21.9644L15.9386 32.1933C17.0084 34.0316 18.4348 35.4844 20.2178 36.5518C22.0602 37.5598 24.1404 38.0639 26.4582 38.0639ZM25.8342 12.536C22.4465 12.536 19.6532 13.7219 17.4541 16.0939C15.2551 18.4658 14.1556 21.49 14.1556 25.1665C14.1556 26.056 14.1853 26.7379 14.2448 27.2123L35.7298 19.296C34.8383 17.2798 33.5605 15.6491 31.8964 14.4039C30.2917 13.1586 28.271 12.536 25.8342 12.536Z",
  fill: "#5440C0"
});

var SvgEc = function SvgEc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 52,
    viewBox: "0 0 76 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ec.0dc0983a.svg";
export { ForwardRef as ReactComponent };